<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：TAG 显示区域
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="tags-container" class="tags-container">
	  <el-tag
		v-for="(item, index) in tags"
		:key="item.label"
		:closable="item.name !== 'home'"
		:effect="$route.name === item.name ? 'dark' : 'plain'"
		@click="clickTag(item)"
		@close="closeTag(item, index)"
		size="small"
		class="custom-tag"
		:class="{ 'active-tag': $route.name === item.name }"
		>
		{{ item.label }}
	  </el-tag>
	</div>
</template>
<script>
//import { mapState } from 'vuex';
import { mapState, mapMutations } from 'vuex';
//import store from '../store';

// 输出元素
export default {
	name: "tags-container",
	props: ['userInfo'],
	data() {
		return {}
	},
	computed: {
		...mapState ({
			tags: state => state.tab.tabsList,
		})
	},
	mounted() {
		// 关闭标签栏
		if(this.userInfo.isopentag == -1) {
			document.getElementById("tags-container").style.display = "none";
		}
		// 仅手机端打开标签栏
		else if(this.userInfo.isopentag == 0) {
			if(window.innerWidth <= 768)
				document.getElementById("tags-container").style.display = "none";
		}
		// 仅电脑端打开标签栏
		else if(this.userInfo.isopentag == 2) {
			if(window.innerWidth > 768)
				document.getElementById("tags-container").style.display = "none";
		}
	},
	methods: {
		// 未成功，感觉与命名空间有关系，未调用成功
		//...mapMutations(['tab/deleteTabs']),
		// 点击TAG 跳转的功能
		clickTag(item) {
			//console.log(item);
			this.$router.push(item.path);
			//this.$router.push({name: item.name});
		},
		// 点击TAG 删除的功能
		closeTag(item, index) {
			// 获得当前TAG最大下标
			const itemLen = this.tags.length - 1;
			
			if(itemLen < 1) {
				this.$message({ type: 'warning', message: '我是底线！ ^_^' });  
				return;
			}
			
			// 删除TAG数据
			this.$store.commit('tab/deleteTabs', index);
			//console.log(this.tab/deleteTabs);
			//this.tab/deleteTabs(item);
			
			// 删除之后的跳转逻辑
			// 如果删除的不是当前激活页面
			if(item.name !== this.$route.name) {
				//console.log("删除的不是当前激活页面");
				return;
			}
			
			// 如果删除的时最后一个TAG
			if(itemLen == index) {
				//console.log("删除的是最后一个");
				this.$router.push(this.tags[index - 1].path);
			}
			else
			{
				//console.log("删除的不是最后一个");
				this.$router.push(this.tags[index].path);
			}
		}
	}
}
</script>
<style lang="less" Scoped>
.tags-container {
    display: flex;
    gap: 8px;
    padding: 5px 10px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    align-items: center;
    flex-wrap: wrap;
    min-height: 50px;
}

.custom-tag {
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    padding: 0px 12px;
	height: 24px;
	align-items: center;
    transition: all 0.3s ease;
    border: 1px solid transparent;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    /deep/ .el-tag__close {
        color: #6c757d;
        font-size: 12px;
        margin-left: 4px;
        
        &:hover {
            color: #495057;
            background-color: rgba(0, 0, 0, 0.1);
        }
    }
}

// 非激活状态标签样式
.custom-tag.el-tag--plain {
    background-color: #fff;
    color: #6c757d;
    border-color: #dee2e6;
	cursor: pointer;
    
    &:hover {
        background-color: #f8f9fa;
        border-color: #adb5bd;
    }
}

// 激活状态标签样式
.active-tag.el-tag--dark {
    background: linear-gradient(135deg, #0099FF 0%, #2575fc 100%);
    border: none;
    color: #fff;
	cursor: pointer;
    
    /deep/ .el-tag__close {
        color: rgba(255, 255, 255, 0.8);
        
        &:hover {
            color: #fff;
            background-color: rgba(255, 255, 255, 0.2);
        }
    }
}

/* 响应式调整 */
@media (max-width: 768px) {
    .tags-container {
        padding: 8px 10px;
        gap: 6px;
        overflow-x: auto;
        flex-wrap: nowrap;
        justify-content: flex-start;
        min-height: 44px;
        
        &::-webkit-scrollbar {
            height: 4px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #ced4da;
            border-radius: 2px;
        }
    }
    
    .custom-tag {
        padding: 0px 10px;
        flex-shrink: 0;
        white-space: nowrap;
    }
}
</style>